import React from 'react';

import { Form, FormikProvider, useFormik } from 'formik';

import LisaImage from 'modules/authentication/presentation/assets/lisa.png';
import { MandatoryPhoneSchema } from 'modules/authentication/presentation/validations';
import { Modal, useModal } from 'shared/presentation/components/atoms';
import { Button, TextInput } from 'shared/presentation/components/molecules';
import { ICONS, MASKS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { useMediaQuery } from 'shared/presentation/hooks';

import * as S from './styles';

interface IPhoneRequiredModalProps {
  loading: boolean;
  onClose: () => void;
  onSubmit: (phone: string) => void;
}

const CloseIcon = ICONS.X;

const ModalCloseButton: React.FC = () => {
  const modal = useModal();

  return (
    <S.CloseButton type="button" onClick={modal.close}>
      <CloseIcon />
    </S.CloseButton>
  );
};

const PhoneRequiredModal: React.FC<IPhoneRequiredModalProps> = ({
  loading,
  onClose,
  onSubmit,
}) => {
  const { t, sharedT, language } = useLocale('authentication');
  const isMobile = useMediaQuery('md');

  const formik = useFormik({
    initialValues: { phone: '' },
    validationSchema: MandatoryPhoneSchema({ t, sharedT, language }),
    onSubmit: values => onSubmit(values.phone),
  });

  return (
    <Modal initialOpen align={isMobile ? 'bottom' : 'center'} onClose={onClose}>
      <S.Container>
        <ModalCloseButton />

        <img src={LisaImage} alt="Lisa" />

        <header>
          <h2>{t('Almost there!')}</h2>
          <p>{t('We need your cellphone number to complete your sign-up')}</p>
        </header>

        <FormikProvider value={formik}>
          <Form>
            <TextInput
              name="phone"
              label={t('Phone')}
              placeholder={t('PHONE_PLACEHOLDER')}
              mask={MASKS.PHONE[language]}
              icon={ICONS.PHONE}
            />

            <Button
              variant="primary"
              type="submit"
              disabled={!formik.isValid}
              loading={loading}
            >
              {t('Continue')}
            </Button>
          </Form>
        </FormikProvider>
      </S.Container>
    </Modal>
  );
};

export default PhoneRequiredModal;
